import * as React from 'react';
export function useListContextValues_unstable(state) {
    const { selection, navigationMode, listItemRole, validateListItem } = state;
    const listContext = {
        selection,
        navigationMode,
        validateListItem
    };
    const synchronousContext = React.useMemo(()=>({
            listItemRole,
            navigationMode
        }), [
        listItemRole,
        navigationMode
    ]);
    return {
        listContext,
        synchronousContext
    };
}
